import { render } from "./ExitAdminModeButton.vue?vue&type=template&id=43b343b5&scoped=true"
import script from "./ExitAdminModeButton.vue?vue&type=script&lang=js"
export * from "./ExitAdminModeButton.vue?vue&type=script&lang=js"

import "./ExitAdminModeButton.vue?vue&type=style&index=0&id=43b343b5&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b343b5"]])

export default __exports__